export const PTLSvgSmallIcon = () => {
	return (
		<>
			<svg width="36" height="24" viewBox="0 0 36 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g id="Pickleball Team Leagues - Abreviated">
					<path
						id="Vector"
						d="M25.2569 24H0L6.69754 2.85067C7.23245 1.16 8.87657 0 10.7431 0H36L29.3025 21.1493C28.7676 22.84 27.1234 24 25.2569 24Z"
						fill="#D0D5DD"
					/>
					<path
						id="Vector_2"
						d="M9.20699 6.84858H12.478C15.1699 6.84858 16.1261 7.91943 15.6253 9.56923L15.3872 10.3538C14.8997 11.9786 13.9378 12.7725 11.0608 12.7725H10.1065L8.86494 16.7252H6.07764L9.20699 6.84766V6.84858ZM10.6025 11.2598H11.1779C12.1171 11.2598 12.3807 10.9384 12.5933 10.2816L12.855 9.43306C13.0667 8.76147 13.0194 8.3196 12.0746 8.3196H11.5219L10.6025 11.2598Z"
						fill="white"
					/>
					<path
						id="Vector_3"
						d="M18.3716 8.48966H16.274L16.7988 6.85352H23.7947L23.2699 8.48966H21.1499L18.5459 16.7412H15.7676L18.3716 8.48966Z"
						fill="white"
					/>
					<path id="Vector_4" d="M24.811 6.85352H27.6206L24.9882 15.0935H28.4964L27.7822 16.7412H21.6733L24.811 6.85352Z" fill="white" />
				</g>
			</svg>
		</>
	);
};
